const carouselItems = [
  {
    title: '热血冒险特辑：燃爆你的夏天',
    desc: '精选最燃热血冒险漫画，从剑与魔法到机甲对决，带你体验最刺激的战斗旅程。本季推荐《剑与魔法录》《机甲纪元》等热门作品。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20manga%20illustration%2C%20warriors%20battling%20dragons%20in%20dramatic%20landscape%2C%20warm%20orange%20and%20gold%20lighting%2C%20anime%20art%20style%2C%20dynamic%20action%20scene%2C%20cinematic%20composition%2C%20professional%20illustration&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '恋爱甜宠季：心动百分百',
    desc: '甜到发腻的恋爱漫画合集，从校园初恋到办公室恋情，每一页都让人心动不已。《甜蜜陷阱》领衔推荐！',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20scene%20with%20couple%20walking%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20sunset%20lighting%2C%20anime%20art%20style%2C%20dreamy%20spring%20atmosphere%2C%20heartwarming%20composition%2C%20cinematic%20feel&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫崛起：原创力量集结',
    desc: '支持国漫原创！《仙途问道》等优质国漫作品推荐，见证中国漫画的飞速成长与独特魅力。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%2C%20martial%20arts%20cultivation%20scene%20with%20floating%20mountains%2C%20ink%20wash%20painting%20aesthetic%2C%20soft%20green%20and%20gold%20tones%2C%20elegant%20traditional%20Chinese%20art%20influence&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '悬疑推理馆：烧脑进行时',
    desc: '喜欢动脑的读者必看！精选高分悬疑推理漫画，反转不断、紧张刺激。《暗夜侦探》带你进入谜团世界。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20noir%20manga%20illustration%2C%20detective%20in%20rainy%20city%20alley%20at%20night%2C%20cool%20blue%20and%20dark%20tones%2C%20dramatic%20street%20lamp%20lighting%2C%20suspenseful%20atmosphere%2C%20cinematic%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '完结神作馆：一次读个够',
    desc: '已完结的高分漫画合集，不用追更等更新，一口气看到结局！收录多部经典完结作品，评分均在9分以上。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20manga%20books%20stacked%2C%20warm%20ambient%20lighting%20from%20window%2C%20soft%20comfortable%20atmosphere%2C%20anime%20aesthetic%2C%20gentle%20afternoon%20light%2C%20clean%20and%20inviting%20composition&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">本周编辑精选专题，发现更多精彩漫画世界</p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col md:flex-row gap-5 bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 cursor-pointer transition-all duration-300 hover:-translate-y-0.5"
            >
              <div className="md:w-[360px] lg:w-[420px] md:flex-shrink-0 aspect-[2/1] md:aspect-auto md:h-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col justify-center p-5 md:p-6 md:pr-8">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3 group-hover:text-primary-500 transition-colors duration-200">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                <div className="mt-4">
                  <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap">
                    探索专题 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}